<template>
  <div
    v-if="!asColumns"
    data-tst="study_graph_solutions"
    class="study-graph-solutions"
    :class="{ 'graph-skeleton': skeleton }"
  >
    <div
      v-if="hasLegend"
      ref="scroll_container"
      class="sol_graph_legend no-scroll-track"
      @wheel.stop="e => wheelScroll(e)"
    >
      <!-- v-for="action in groupingSolution" -->
      <!-- `clr-${action.css_class}${useDefaultClrs ? '-default' : ''}`, -->
      <!-- : `color:${action[`${useDefaultClrs ? 'hex_default' : 'hex'}`]}` -->

      <!-- { 'no-events': readOnly }, -->
      <div
        v-for="(action, aIdx) in legendActions"
        :key="`${action.code}_${aIdx}`"
        v-ripple
        :class="[
          `clr-${action.css_class}`,
          {
            sol_graph_legend_item_active: filterActions.some(i => i.code === action.code),
          },
        ]"
        :style="`${useHex ? `color:${action.hex}` : ''}`"
        class="sol_graph_legend_item uppercase"
        @click="
          toggleAction(
            action,
            filterActions.some(i => i.code === action.code),
          )
        "
      >
        <div>
          {{ action.display_name }}
          <span class="sol_graph_legend_item_bet">
            <span v-html="getBetHtml({ showBetsIn, a: action, simple: true })"></span>
          </span>
        </div>
        <div
          class="clr-white ml-2"
          :data-tst="`graph_action_${action.code}_${action.raise_amount || 0}`"
        >
          {{ numFixedUnit(action[freKey] * 100, 'strategy') }}%
        </div>
      </div>
    </div>
    <div class="sol_graph">
      <div
        v-for="(action, aIdx) in solution"
        :key="`${action.code}_${aIdx}`"
        class="sol_graph_item"
        :class="`${action.css_class}`"
        :style="`width: ${action[freKey] * 100}%; ${useHex ? `background:${action.hex}` : ''}`"
      />
      <slot />
    </div>
  </div>
  <div
    v-else
    class="study-graph-solutions graph-vertical w-100"
  >
    <table class="ab_player ab_player_table">
      <tr
        v-for="(action, aIdx) in groupingSolution"
        :key="`${action.code}_${aIdx}`"
        :class="[
          {
            sol_graph_legend_item_active:
              grouping !== 'swv_grouping_none'
                ? action.selected || filterActions.some(i => i.code === action.code)
                : filterActions.some(i => i.code === action.code),
          },
        ]"
        @click="
          toggleAction(
            action,
            filterActions.some(i => i.code === action.code),
          )
        "
      >
        <td
          class="sol_graph_legend_item uppercase"
          :class="`clr-${action.css_class}`"
          :style="`${useHex ? `color:${action.hex}` : ''}`"
        >
          <div v-if="action.group_id">
            <!-- {{
              action.group_id === 'raise_all' ||
              action.group_id === 'bet_overbet'
                ? ''
                : action.display_name
            }} -->

            <span class="sol_graph_legend_item_bet">
              {{ $t(`browse.${action.group_display_name}`) }}
            </span>
          </div>
          <div v-else>
            {{ action.display_name }}
            <span class="sol_graph_legend_item_bet">
              <span v-html="getBetHtml({ showBetsIn, a: action, simple: false })"></span>
            </span>
          </div>
        </td>
        <td>
          <div
            class="clr-white px-2"
            :data-tst="`graph_action_${action.code}_${action.raise_amount || 0}`"
          >
            {{ numFixedUnit(action[freKey] * 100, 'strategy') }}%
          </div>
        </td>
        <td class="w-100">
          <div
            class="sol_graph_item"
            :class="`${action.css_class}`"
            :style="`width: ${action[freKey] * 100}%; ${useHex ? `background:${action.hex}` : ''}`"
          />
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import format_mix from '@/mixins/format_mix'
import horizontalScroll_mix from '@/components/HorizolnalScroller/horizontalScroll_mix'
import { getImportantActions } from '@/helpers/grouping'

export default {
  name: 'StudyGraphSolutions',
  mixins: [format_mix, horizontalScroll_mix],
  props: {
    asColumns: Boolean,
    hasLegend: { type: Boolean, default: true },
    skeleton: Boolean,
    limitLegendTo: { default: 0 },
    legendRaiseFirst: { type: Boolean, default: true },
    filterActions: { default: () => [] },

    customSolution: Array,
    // actions: Array,
    // readOnly: Boolean,
    useHex: Boolean,
    // useDefaultClrs: Boolean,
    freKey: { default: () => 'total_frequency' },
  },
  data() {
    return {
      possSolutions: [],
      noFit: false,
    }
  },
  computed: {
    grouping() {
      return this.$store.getters.sw_actions_grouping
    },
    solution() {
      if (this.customSolution) {
        return this.customSolution
      }
      const res = this.sol.study_computed_solution
      return res
    },
    showBetsIn() {
      const { show_bets_in } = this.$store.getters
      return show_bets_in
    },
    legendActions() {
      let res = this.solution
      if (this.limitLegendTo) {
        res = getImportantActions({
          actions: res,
          max: this.limitLegendTo,
          sortKey: this.freKey,
          raisesFirst: this.legendRaiseFirst,
        })
      }
      res = getImportantActions({
        actions: res,
        max: 99,
        sortKey: this.freKey,
        raisesFirst: this.legendRaiseFirst,
      })
      return res
    },
  },
}
</script>

<style lang="scss" scoped>
.graph-small {
  .sol_graph {
    height: 0.25em !important;
  }
}
.graph-big {
  .sol_graph {
    margin: 0.25em 0 0 0;
    &_legend {
      &_item {
        font-weight: 700;
      }
    }
  }
}
.graph-centered {
  .sol_graph {
    &_legend {
      margin: 0 auto;
      // justify-content: center;
      // justify-content: safe center;
      &_item {
        &:first-child {
          margin-left: auto;
        }
        &:last-child {
          margin-right: auto;
        }
      }
    }
  }
}
.graph-legend-bold {
  .sol_graph {
    &_legend {
      &_item {
        font-weight: 700;
      }
    }
  }
}

.graph-legend-wrap {
  .sol_graph {
    &_legend {
      flex-wrap: wrap;
    }
  }
}

.graph-grid {
  --grid-template-columns: repeat(1, 1fr);
  .sol_graph_legend {
    display: grid !important;
    grid-template-columns: var(--grid-template-columns);
    margin-bottom: 0.25em;
  }
  .sol_graph_legend_item {
    justify-content: space-between;
    line-height: 1.2;
    --legend-item-padding: 0;
    --legend-item-margin: 0;
    &:after {
      display: none;
    }
  }
}

.graph-skeleton {
  --clr-back: var(--clr-white-0);
  .sol_graph_legend {
    &_item {
      opacity: 0 !important;
    }
    &:before {
      content: '';
      height: 0.8em;
      width: 100%;
      max-width: 22em;
      z-index: 1;
      background: var(--clr-back);
      position: absolute;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
      top: 50%;
      border-radius: 99px;
      animation: opacityPulse 2s infinite;
    }
  }
  .sol_graph {
    &:before {
      content: '';
      height: 100%;
      width: 100%;
      z-index: 1;
      background: var(--clr-back);
      position: absolute;
      animation: opacityPulse 2s infinite;
    }
  }
  @keyframes opacityPulse {
    0% {
      opacity: 0.05;
    }
    50% {
      opacity: 0.1;
    }
    100% {
      opacity: 0.05;
    }
  }
}

.study-graph-solutions {
  // display: flex;
  // flex: 1;
  // flex-direction: column;
  width: 100%;
  position: relative;
  --legend-item-padding: 0 0.25em 0 0;
  --legend-item-margin: 0 0.75em 0 0;
  --legend-item-weight: 500;
  --legend-item-size: 0.875em;
  // --chart-height: 1em;
  --chart-height: 0.875rem;
  --chart-radius: 99px;
  --clr-back: var(--clr-black-2);
  .sol_graph_legend_item_active {
    background: var(--clr-black-1);
  }
  .sol_graph {
    width: 100%;
    display: flex;
    background: var(--clr-back);
    height: var(--chart-height);
    overflow: hidden;
    border-radius: var(--chart-radius);
    position: relative;
    &_item {
      min-height: 100%;
      transition: width 0.2s;
      will-change: width;
    }
    &_legend {
      display: flex;
      overflow: auto;
      max-width: 100%;
      position: relative;
      &_item {
        border-radius: 8px;
        display: flex;
        white-space: nowrap;
        margin: var(--legend-item-margin);
        padding: var(--legend-item-padding);
        position: relative;
        font-size: var(--legend-item-size);
        font-weight: var(--legend-item-weight);
        &:last-child {
          &:after {
            display: none;
          }
        }
        &:after {
          content: '';
          height: 4px;
          width: 4px;
          background: var(--clr-grey-2);
          border-radius: 50%;
          position: absolute;
          right: -0.5em;
          top: 0;
          bottom: 0;
          margin: auto;
        }
      }
    }
  }
}

.graph-vertical {
  // flex: 0;
  // display: flex;
  // flex-direction: column;
  // flex: 0 !important;
  // display: block;
  table {
    border-spacing: 0;
  }
  // &_in-box {
  //   tr {
  //     &:after {
  //       width: 150% !important;
  //       left: -16px !important;
  //     }
  //   }
  // }
  tr {
    cursor: pointer;
    td {
      z-index: 1;
      position: relative;
    }
    &:after {
      opacity: 0;
      z-index: 0;
      content: '';
      position: absolute;
      pointer-events: none;
      height: calc(1.5em + 4px);
      width: 100%;
      left: -1rem;
      top: 0;
      background: linear-gradient(to left, transparent, rgba(255, 255, 255, 0.0825));
    }
    // &:hover {
    //   &:after {
    //     opacity: 1;
    //   }
    // }
  }
  .sol_graph_legend_item_active {
    position: relative;
    // https://github.com/w3c/csswg-drafts/issues/1899#issuecomment-338773780
    transform: scale(1);
    background: none !important;
    &:after {
      opacity: 1;
    }
  }

  .sol_graph_legend_item {
    margin: 2px 0;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    padding: 0 4px;
    &:after {
      display: none;
    }
  }
  .sol_graph_item {
    height: 1.5em;
    margin: 2px 0;
    border-radius: 4px;
  }
}

@media (hover: hover) and (pointer: fine) {
  .graph-vertical {
    tr {
      &:hover {
        &:after {
          opacity: 1;
        }
      }
    }
  }
}
</style>
